import React, { useState, useEffect } from "react";
import UserPanel from "../Dashboard/UserPanel";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import OverView3 from "../Dashboard/Overview3";
import { useMachine } from "../../context/MachineContext";
import UserPanel2 from "../Dashboard/UserPanel2";

import MonthlyRequirementForm from "../AdvancedAnalysis/MonthlyRequirementForm";
import OverView2 from "../BatchControl/OverView2";
import MonthlyProductionStatus from "../BatchControl/MonthlyProductionStatus";
import axios from "axios";
import GraphPlotGoodBad from "./GraphplotGoodBad";
import ProductionUserPanel from "./ProductionUserPanel";


const ProductionDemand = () => {
  const authToken = localStorage.getItem("access");
  const location = useLocation();
  const navigate = useNavigate();
  const [parts, setParts] = useState([]);
  const machine = location.state?.part;
   const [isLoading, setIsLoading] = useState(false);
  // const [selectedChildPart, setSelectedChildPart] = useState("");
  const [machines, setMachines] = useState([]);
  //const { selectedMachineId } = useMachine();
  const [partNum, setPartNum] = useState("");
  const selectedMachineId = localStorage.getItem('selectedMachineId');
  const [selectedMachine, setSelectedMachine] = useState(machine?.machine_id || selectedMachineId);
  const [operators, setOperators] = useState([]);
  const [selectedPart, setSelectedPart] = useState("");
  useEffect(() => {
    fetchMachine();
  }, []);
  const fetchMachine = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/api/machines/by-company/?id=3");
      if (response.ok) {
        const machines = await response.json();
        console.log("daaaaaaaaaaaaaaaata", machines?.data)
        setMachines(machines?.data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        // localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (!selectedMachine) return;

    axios
      .get(`https://api.hanoch.in/api/mcc-parts/?machine_id=${selectedMachine}`)
      .then((res) => setParts(res.data || []))
      .catch((err) => console.error(err));
  }, [selectedMachine]);
  const selectedMachineObject = machines.find(m => m.id == selectedMachine);
  const isManual = selectedMachineObject?.manual ?? false;
  const selectedChildPart = selectedMachineObject?.parts;
  const [partsData, setPartsData] = useState({
    good_parts: 1,
    bad_parts: 0,
    total_parts: 0,
    total_running_hours: 0,
    stopped_time: 0,
  });
  const [partsMData, setPartsMData] = useState({
    good_parts: 1,
    bad_parts: 0,
    total_parts: 0,
    total_running_hours: 0,
    machine: "machine name",
    part: "part name",
    part_number: 0,
  });


  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    // console.log( `${year}-${month}-${day}`,'yyyyyyy');
    return `${year}-${month}-${day}`;
  };
  const [selectedDate, setSelectedDate] = useState(() => machine?.date || getTodayDate());
  const today = new Date();

// const [selectedYear, setSelectedYear] = useState(
//   machine?.year ?? today.getFullYear()
// );

// const [selectedMonth, setSelectedMonth] = useState(
//   machine?.month ?? today.getMonth() + 1 // 1–12
// );

 const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });
  const [year, month] = selectedMonth.split("-");
  const isShiftDisabled = (shift) => {
    const now = new Date();
    const currentHour = now.getHours();

    if (shift === "1") {
      return currentHour < 6; // After 2 PM, Shift 1 is over
    } else if (shift === "2") {
      return currentHour < 14; // After 10 PM, Shift 2 is over
    } else if (shift === "3") {
      return currentHour < 22 && currentHour >= 6;
      // Shift 3 (10PM-6AM) is *upcoming* if it's between 6 AM to 10 PM
    }
    return false;
  };

  const getCurrentShift = () => {
    const now = new Date();
    const hours = now.getHours();
    if (hours >= 6 && hours < 14) {
      return 1; // Shift 1: 6am to 2pm
    } else if (hours >= 14 && hours < 22) {
      return 2; // Shift 2: 2pm to 10pm
    } else {
      return 3; // Shift 3: 10pm to 6am
    }
  };
  const [selectedShift, setSelectedShift] = useState(() => machine?.shift || getCurrentShift());

  const fetchPLCData = async (selectedMonth,selectedPart,selectedYear, selectedMachine) => {
     if (!selectedDate || !selectedShift || !selectedMachine || !selectedPart) return;

    try {
 setIsLoading(true);

    const response = await axios.get(
     
      `https://api.hanoch.in/api/get-mcc-machine-monthly-data/?part_id=${selectedPart}&machine_id=${selectedMachine}&year=${selectedYear}&month=${selectedMonth}`
    );
    const data = response;
    console.log("d",data)
    setPartNum(data?.part_number);
    setPartsData({
      ...partsData,
      bad_parts: data?.bad_products || 0,
      good_parts: data?.good_products || 0,
      stopped_time: data?.stopped_time || 0,
      total_parts: data?.total_count || 0,
      total_running_hours: data?.machine_running_hours || 0,
      machine: data?.machine_name || "machine name",
      part: data?.part || "part name",
      part_number: data?.part_number || 0,
      })
    } catch (err) {
      console.error(err);
      setPartsData([]);
    } finally {
      setIsLoading(false);
    }
  }
    
  
  const fetchPLCDataManual = async (date = selectedDate, shift = selectedShift, selectedMachine) => {
    const response = await fetch(
      `https://api.hanoch.in/api/manual-machine-shift-data/?shift=${shift}&date=${date}&machine_id=${selectedMachine}`
    );
    const data = await response.json();
    setPartsMData({
      ...partsMData,
      bad_parts: data?.bad_products || 0,
      good_parts: data?.good_products || 0,
      total_parts: data?.total_count || 0,
      total_running_hours: data?.machine_running_hours || 0,
      machine: data?.machine_name || "machine name",
      part: data?.part || "part name",
      part_number: data?.part_number || 0,
    });
    console.log("daata", partsData)
  };
 useEffect(() => {
     if (parts.length > 0 && !selectedPart) {
      setSelectedPart(parts[0].id);
    }
 }, [parts]);
  // let part_num= partsData?.part_number ||0;
  useEffect(() => {
    if (selectedDate && selectedShift && selectedMachine) {
      if (isManual === true) {
        fetchPLCDataManual(selectedDate, selectedShift, selectedMachine);
      }
      else {
        fetchPLCData(month,selectedPart,year, selectedMachine);
      }
    }
  }, [selectedDate, selectedShift, selectedMachine, isManual,month,selectedPart,year]);
  useEffect(() => {
    let intervalId;
    const fetchAndSchedule = async () => {
      if (selectedDate && selectedShift && selectedMachine) {
        await fetchPLCData(selectedDate, selectedShift, selectedMachine);
      }
    };
    fetchAndSchedule();
    intervalId = setInterval(() => {
      const now = new Date();
      const today = now.toISOString().split("T")[0];
      const currentShift = getCurrentShift();

      if (selectedDate === today && Number(selectedShift) === currentShift) {
        fetchAndSchedule();
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [selectedDate, selectedShift, selectedMachine]);

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);
  };
  const handleMachineChange = (event) => {
    const machineId = event.target.value;
    setSelectedMachine(machineId);
  };
  const handleShiftChange = (event) => {
    const newShift = event.target.value;
    setSelectedShift(newShift);
  };
  const [partsDataMap, setPartsDataMap] = useState({
    goodPartsList: [],
    badPartsList: [],
    dateTimeList: [],
  });

  document.title = "Batch Control | OptiMize ";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Production Demand" />
<Card>
  <CardBody className="p-1">
 <div className="d-flex flex-wrap align-items-center mb-3"
            style={{
              gap: "12px",
              padding: "12px 16px",
              // backgroundColor: "#252b3b",
              color: "#c9d1d9",
              borderRadius: "6px",
              width: "100%"
            }}>
            <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginRight: "6px",
                marginBottom: 0,
                color: "#8b949e"
              }}>Select Machine:</label>
              <select
                className="form-control"
                id="machine"
                name="selectedMachine"
                value={selectedMachine || ""}

                onChange={handleMachineChange}
              >
                <option key="default">Select Machine</option>
                {machines?.map((machine, index) => (
                  <option key={index} value={machine.id}>
                    {machine.name}
                  </option>
                ))}
              </select>
            </div>

            {/* <div style={{
              backgroundColor: "#21262d",
              padding: "4px 10px",
              borderRadius: "6px",
              border: "1px solid #30363d"
            }}>
              <span style={{ fontWeight: "600", fontSize: "16px" }}>{partsData?.part}</span>
            </div> */}

            <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginRight: "6px",
                marginBottom: 0,
                color: "#8b949e"
              }}> Select Part:</label>
              <select
                className="form-control"
                id="part"
                name="selectedPart"
                value={selectedPart}
                onChange={(e) => setSelectedPart(e.target.value)}
              >
                <option value="">Select Part</option>
                {parts.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.part_name}
                  </option>
                ))}
              </select>
            </div>
            {/* Shift Selector */}
            {/* <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginRight: "6px",
                marginBottom: 0,
                color: "#8b949e"
              }}>Shift:</label>
              <select
                value={selectedShift}
                onChange={handleShiftChange}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "#21262d",
                  color: "#c9d1d9",
                  border: "1px solid #30363d",
                  borderRadius: "6px",
                  fontSize: "13px"
                }}
              >
                <option value="">Select shift</option>
                <option value="1" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("1")}>6-2 (Shift 1)</option>
                <option value="2" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("2")}>2-10 (Shift 2)</option>
                <option value="3" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("3")}>10-6 (Shift 3)</option>
              </select>
            </div> */}

            <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginRight: "6px",
                marginBottom: 0,
                color: "#8b949e"
              }}>Select Month:</label>
             <input
  type="month"
  value={selectedMonth}
  max={new Date().toISOString().slice(0, 7)}
  onChange={(e) => {
    const [year, month] = e.target.value.split("-");
    year(Number(year));
    month(Number(month));
  }}
  style={{
    padding: "4px 8px",
    // backgroundColor: "#21262d",
    // color: "#c9d1d9",
    border: "1px solid #30363d",
    borderRadius: "6px",
    fontSize: "13px",
  }}
/>

            </div>
          </div>
  </CardBody>
</Card>
         
          {isManual ? (
            <UserPanel2 partsData={partsMData}
              selectedChildPart={partsMData.part_number} />
          ) : (
            <UserPanel partsData={partsData}
              selectedChildPart={partsData.part_number} />
          )}
          <MonthlyProductionStatus
            machineId={selectedMachine}
            partId={selectedPart}
            year={year}
            month={month}
          />
          {isManual ? (
            <OverView2 partsDataMap={partsDataMap}
              selectedDate={selectedDate}
              selectedShift={selectedShift}
              selectedMachine={selectedMachine}
              selectedChildPart={selectedChildPart}

            />
          ) : (
            <GraphPlotGoodBad partsDataMap={partsDataMap}
              selectedDate={selectedDate}
              selectedShift={selectedShift}
              selectedMachine={selectedMachine}
              selectedChildPart={selectedChildPart}
              partId={selectedPart}
              year={year}
              month={month}
            />
          )}
          <MonthlyRequirementForm />

        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProductionDemand;
